import { render, staticRenderFns } from "./TiemposDeCocina.vue?vue&type=template&id=6d45a1fa&scoped=true"
import script from "./TiemposDeCocina.vue?vue&type=script&lang=js"
export * from "./TiemposDeCocina.vue?vue&type=script&lang=js"
import style0 from "./TiemposDeCocina.vue?vue&type=style&index=0&id=6d45a1fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d45a1fa",
  null
  
)

export default component.exports